import axios from 'axios';
import React, {Component} from 'react';
import SVGInline from 'react-svg-inline';
import renderHTML from 'react-render-html';
import { bindActionCreators } from "redux"
import { compose, withProps, lifecycle, withStateHandlers } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps"
import {connect} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Article from './main/article';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';

const WP_API_ENDPOINT = `${RT_API.root}wp/v2`;

class MapFull extends Component {
	
	constructor(props) {
	    super(props)
	    this.state = {
	      selectedMarker: false
	    }
	}
	
	componentWillUpdate() {
		window.scrollTo(0, 0);
	}
	
	posts(){
		let posts = this.props.posts
		//delete events.loading
		return Object.entries(posts)

	}
	
	isSingle() {
		return 1 === this.props.posts.length;
	}
	
	logVars(icon) {
		console.log("icon path: ")
		console.log(icon)
	}
	
	renderMarkers(posts) {
		if (posts.length) {
			return posts.map( post => {
				if (post.Marker) {
					//console.log(post);
					let imageUrl = null;
					let imageWidth = 0;
					let imageHeight = 0;
					var icon = null;
					var size = {};
					switch (this.props.category) {
				        case 'wineries':
				        	icon = "/wp-content/themes/chester-county-kiosk/images/Wine.svg";
				        	size = { width: 54, height: 54 }
						    break;
						case 'breweries':
				        	icon = "/wp-content/themes/chester-county-kiosk/images/Beer.svg";
				        	size = { width: 54, height: 54 }
						    break;
						case 'spirits':
				        	icon = "/wp-content/themes/chester-county-kiosk/images/Spirits.svg";
				        	size = { width: 46, height: 46 }
						    break;
			        }
			        let iconUrl = icon;
					if (post.featured_media !== 0 ){
						imageUrl = post.better_featured_image.source_url;
						imageWidth = post.better_featured_image.media_details.width; 
						imageHeight = post.better_featured_image.media_details.height;
					} 					
					let thisID = post.id;
					let latVal = parseFloat(post.Marker.geometry.coordinates[1]);
					let lngVal = parseFloat(post.Marker.geometry.coordinates[0]);
					//setup marker object
					const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }, header: post.Marker.properties.description, content: post.content.rendered, image: imageUrl, imageW: imageWidth, imageH: imageHeight, icon: iconUrl, size: size};
					//console.log(coords);
					return (coords);
				} else {
					return null;
				}
			});
		} else {
			const counter = [...Array(1)];
			return counter.map((val, i) => {
				let thisID = i;
				let latVal = parseFloat(39.950177 + (i / 100));
				let lngVal = parseFloat(-75.590137 + (i / 100));
				const coords = {id: thisID, coords: { lat: latVal, lng: lngVal }};
				//console.log(markerPos);
				return (coords);
			});
		}
		
	}

	
	render() {		
		const marketState = withStateHandlers({
			isOpen: false
		}, {
			onMarkerClick: ({isOpen}) => () => ({isOpen: !isOpen})
		})


	        // This is the key!
		const MarkerPoint = compose(marketState)(props =>
			
			<Marker 
				key={props.marker.id}
			    position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
			    onClick={() => props.onMarkerClick()}
			    icon={{url: props.marker.icon, scaledSize: props.marker.size}} >
			    >
				{props.isOpen &&
				   	<InfoWindow 
				   		position={{lat: props.marker.coords.lat, lng: props.marker.coords.lng}}
				        onCloseClick={() => props.onMarkerClick()}>
					    <div>
					    	{ props.marker.image !== '' &&
							    	<img className="alignright pop-image" src={ props.marker.image } width={props.marker.imageWidth} height={props.marker.imageHeight}/>
					    	}
					    	{ renderHTML( props.marker.header ) }
					    	<br />
					    	{ renderHTML( props.marker.content ) }
					    	
					    </div>
				    </InfoWindow>
				}
			</Marker>
		)
	
		const MapWithMarkers = compose(withScriptjs, withGoogleMap)(props =>
			<GoogleMap key={Math.floor(Math.random() * 100)} 
				defaultZoom={this.props.zoom}
				defaultCenter={this.props.center}>
				{
					props.markers.map((marker) => {
						if (marker){
							return (<MarkerPoint marker={marker} />)
						} else {
							return null;
						}
					})
				}
			</GoogleMap>
		)
	
		return (
				<MapWithMarkers
				    markers={this.renderMarkers(this.props.posts)}
				    zoom={this.props.zoom}
				    cetner={this.props.center}
				    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDlm1GMaQ12XiEttSQP7ay5AO9Y_um4LaQ&v=3.exp&libraries=geometry,drawing,places"
				    loadingElement={<div style={{ height: `100%` }}/>}
				    containerElement={<div id="map"/>}
				    mapElement={<div style={{ height: `100%`}} />}
				    />
		);
	}
}


function mapStateToProps({posts}) {
	return {posts};
}

export default connect(mapStateToProps)(MapFull)



// WEBPACK FOOTER //
// ./src/components/map-full.js